import { render, staticRenderFns } from "./ChecklistFilledDetailsField.vue?vue&type=template&id=1b413ded&scoped=true"
import script from "./ChecklistFilledDetailsField.vue?vue&type=script&lang=js"
export * from "./ChecklistFilledDetailsField.vue?vue&type=script&lang=js"
import style0 from "./ChecklistFilledDetailsField.vue?vue&type=style&index=0&id=1b413ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b413ded",
  null
  
)

export default component.exports